export const Screens = {
  HOME: "Home",
  LOGIN: "Login",
  REGISTER: "Register",
  SEARCH: "Search",
  PROFILE: "Profile",
  NOTIFICATIONS: "Notifications",
  EDIT_PROFILE: "Edit Profile",
  SETTINGS: "Settings",
};

export const RequestState = {
  IDLE: "idle",
  REQUESTED: "requested",
  RECEIVED: "received",
};
